<template>
  <div class="f_left">
    <h2>生产进度</h2>
    <div class="list">
      <ul class="list_li">
        <li v-for="(item, index) in header" :key="index">
          {{ item.display_name }}
        </li>
      </ul>
      <ul id="icon" class="list_li_two">
        <li v-for="(item, index) in rows" :key="index">
          <div v-for="(value, i) in item" :key="i">{{ value }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Fleft",
  data() {
    return {
      header: [],
      rows: [],
      height: 0,
    };
  },
  created() {
    this.$axios
      .get(
        `${this.$url}/admin/bigpin12`
      )
      .then((res) => {
        let datas = JSON.parse(res.data.split("<\/script>")[1]).data;
        this.header = datas.cols;
        this.rows = datas.rows;
        setInterval(() => {
          this.scroll();
        }, 1000);
      });
  },
  methods: {
    scroll() {
      let liHeight = document.querySelectorAll("#icon li")[0].clientHeight;
      let ul = document.querySelectorAll(".list_li_two")[0];
      if (this.height >= ul.clientHeight - 80) {
        this.height = 0;
      }
      this.height += liHeight;
      ul.style.transform = `translate(0,-${this.height}px)`;
    },
  },
};
</script>

<style lang="less" scoped>
.f_left {
  width: 100%;
  height: 100%;
  h2 {
    color: rgb(14, 242, 245);
    font-size: 1.25rem;
    margin-left: 3.125rem;
    padding: 1rem 0;
  }
  .list {
    width: 100%;
    height: 50%;
    background: url("~@/assets/image/框E.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    padding: 0.625rem;
    padding-top: 0;
    .list_li {
      display: flex;
      position: relative;
      z-index: 999;
      padding: 0.625rem 0;
      background-color: rgb(4, 27, 56);
      li {
        flex: 1;
        &:last-of-type {
          flex: 2;
        }
      }
    }
    .list_li_two {
      transition: all 1s;
      li {
        display: flex;
        padding: 0.625rem 0;
        &:nth-child(2n) {
          background-color: rgb(47, 77, 101);
        }
        div {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:last-of-type {
            flex: 2;
          }
        }
      }
    }
  }
}
</style>